var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHours(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.6319 49.6842C65.7729 62.7543 53.1366 71.5353 39.1875 71.5353C20.696 71.5353 5.65222 56.4915 5.65222 38C5.65222 19.5085 20.696 4.46472 39.1875 4.46472C48.0416 4.46472 56.328 7.86603 62.5479 13.9305L58.2014 13.549L57.8118 17.9969L69.5111 19.0226L70.5368 7.3233L66.0889 6.93307L65.748 10.8278C62.9421 8.0881 59.7154 5.77573 56.2271 4.02347C50.9123 1.35391 45.1795 0 39.1875 0C29.0375 0 19.4946 3.95273 12.3174 11.1299C5.14023 18.3071 1.1875 27.85 1.1875 38C1.1875 48.15 5.14023 57.6929 12.3174 64.8701C19.4946 72.0473 29.0375 76 39.1875 76C47.0964 76 54.6778 73.5937 61.1122 69.0408C67.4034 64.5894 72.1424 58.4339 74.8166 51.2399L70.6319 49.6842Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1313 14.6785C26.2717 14.6785 15.8098 25.1404 15.8098 38C15.8098 50.8596 26.2717 61.3215 39.1313 61.3215C51.9908 61.3215 62.4528 50.8596 62.4528 38C62.4528 25.1404 51.9908 14.6785 39.1313 14.6785ZM48.1111 40.2324H36.9522V24.2197H41.417V35.7676H48.1111V40.2324Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHours);
export default __webpack_public_path__ + "static/media/hours.1c073a7bc9246a9540984693e1a95292.svg";
export { ForwardRef as ReactComponent };